export default __webpack_public_path__ + "static/media/close-responsive-card.fe818370.svg";